<template>
  <div class="goodsManageSet">
    <div class="banner">
      <img src="../../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">商品管理</div>
    </div>
    <div class="tit">商品介绍详情管理</div>

    <div class="main_content">
      <div class="data_list" v-if="dataList.length > 0">
        <div class="item_card" v-for="item in dataList" :key="item.id">
          <div class="text">
            <p>商品：{{ detail.commodityname }}</p>
            <p>
              指定样式内容：{{
                item.conttype == 1
                  ? "图片"
                  : item.conttype == 2
                  ? "视频"
                  : "文本"
              }}
            </p>
          </div>
          <div class="img_box" v-if="item.conttype == 1">
            <van-image width="100%" height="100%" :src="item.picurl">
            </van-image>
          </div>
          <div class="img_box" v-if="item.conttype == 2">
            <video :src="item.videourl" controls :poster="item.picurl"></video>
            <!-- <van-image width="100%" height="100%" :src="item.pic"> </van-image> -->
          </div>
          <div class="content_box" v-if="item.conttype == 3">
            <p v-html="item.details"></p>
          </div>

          <div class="editBtn" @click="handleEdit(item.id)">编辑详情→</div>
        </div>
      </div>

      <van-empty description="您还没有添加商品详情" v-else />
    </div>

    <div class="primary-button" @click="handleEdit(0)" v-if="dataList.length > 0">编辑全部</div>

    <div class="return-fixd flex-rowc">
      <div class="primary-button" @click="handleAdd(false)">+新增商品详情</div>
      <div class="default-button" @click="handleReturn">返回</div>
    </div>
  </div>
</template>

<script>
import { getCommidityDetail } from "../../../api/api";
export default {
  name: "cIntroDetail",
  data() {
    return {
      detail: "",
      dataList: [],
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
        let { id } = this.$route.params;
      getCommidityDetail({ id }).then((res) => {
        this.detail = res;
        this.dataList = res.details ? res.details : [];
        this.dataList.sort((a, b) => a.sortno - b.sortno)
        Toast.clear();
      });
    },

    handleReturn() {
      history.back();
    },

    handleEdit(id) {
      let cmId = this.$route.params.id;
      this.$router.push(
        `/commondityIndex/cManageEdit/cIntroDetailSet/${cmId}/0/${id}`
      );
    },
    handleAdd() {
      let cmId = this.$route.params.id;
      this.$router.push(
        `/commondityIndex/cManageEdit/cIntroDetailSet/${cmId}/1/0`
      );
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .tit {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 50px;
  }
  .input_box {
    &.search {
      margin-bottom: 30px;
    }
  }
  .main_content {
    .item_card {
      border: 2px solid #dedede;
      border-radius: 30px;
      width: 650px;
      padding: 45px 37px 85px;
      box-sizing: border-box;
      margin: auto;
      position: relative;
      margin-bottom: 60px;
      .text {
        margin-bottom: 20px;
      }
      .img_box {
        width: 250px;
        height: 250px;
        margin: auto;
        background: #e8e8e8;
        margin-bottom: 45px;
        video {
          width: 100%;
          height: 100%;
        }
      }
      p {
        font-size: 22px;
        color: #404d6c;
        text-align: left;
        line-height: 45px;
      }
      .editBtn {
        position: absolute;
        width: 200px;
        height: 50px;
        line-height: 50px;
        background: #6e5c86;
        border-radius: 25px;
        font-size: 20px;
        color: #fff;
        right: 20px;
        bottom: 20px;
        text-align: center;
      }
    }
  }
}
</style>